// TermsAndConditions.jsx

import React from 'react';
import Layout from '../Layout';
import BreadCrump from '../breadcrump/BreadCrump';
import Container from '../../ui/container/Container';

const TermsAndConditions = () => {
  return (
     <Layout>
<BreadCrump />

    <Container>
      <h1 className="text-2xl font-bold mb-6">Terms &amp; Conditions</h1>

      <p className="text-sm mb-4">
        This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
      </p>

      <p className="text-sm mb-4">
        This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of domain name cineguru.in ('Website'), including the related mobile site and mobile application (hereinafter referred to as 'Platform').
      </p>

      <p className="text-sm mb-4">
        The Platform is owned by CineGuru, a company incorporated under the Companies Act, 1956 with its registered office at 129, Kartik building, Link road, Andheri West, Mumbai, India (hereinafter referred to as ‘Platform Owner’, 'we', 'us', 'our').
      </p>

      <p className="text-sm mb-4">
        Your use of the Platform and services and tools are governed by the following terms and conditions (‘Terms of Use’) as applicable to the Platform including the applicable policies which are incorporated herein by way of reference. If you transact on the Platform, you shall be subject to the policies that are applicable to the Platform for such transaction. By mere use of the Platform, you shall be contracting with the Platform Owner and these terms and conditions including the policies constitute your binding obligations with the Platform Owner.
      </p>

      <p className="text-sm mb-4">
        Any terms and conditions proposed by you which are in addition to or which conflict with these Terms of Use are expressly rejected by the Platform Owner and shall be of no force or effect. These Terms of Use can be modified at any time without assigning any reason. It is your responsibility to periodically review these Terms of Use to stay informed of updates.
      </p>

      <p className="text-sm mb-6">
        For the purpose of these Terms of Use, wherever the context so requires ‘you’, ‘your’ or ‘user’ shall mean any natural or legal person who has agreed to become a user/buyer on the Platform.
      </p>

      <p className="text-base font-semibold mb-4">ACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE, SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE PROCEEDING.</p>

      <ul className="list-disc list-inside text-sm space-y-3">
        <li>
          To access and use the Services, you agree to provide true, accurate and complete information to us during and after registration, and you shall be responsible for all acts done through the use of your registered account on the Platform.
        </li>
        <li>
          Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials offered on this website or through the Services, for any specific purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
        </li>
        <li>
          Your use of our Services and the Platform is solely and entirely at your own risk and discretion for which we shall not be liable to you in any manner. You are required to independently assess and ensure that the Services meet your requirements.
        </li>
        <li>
          The contents of the Platform and the Services are proprietary to us and are licensed to us. You will not have any authority to claim any intellectual property rights, title, or interest in its contents. The contents include but are not limited to the design, layout, look and graphics.
        </li>
        <li>
          You acknowledge that unauthorized use of the Platform and/or the Services may lead to action against you as per these Terms of Use and/or applicable laws.
        </li>
        <li>
          You agree to pay us the charges associated with availing the Services.
        </li>
        <li>
          You agree not to use the Platform and/or Services for any purpose that is unlawful, illegal or forbidden by these Terms, or Indian or local laws that might apply to you.
        </li>
        <li>
          You acknowledge that the website and the Services may contain links to other third-party websites. On accessing these links, you will be governed by the terms of use, privacy policy and such other policies of such third-party websites. These links are provided for your convenience to provide further information.
        </li>
        <li>
          You understand that upon initiating a transaction for availing the Services you are entering into a legally binding and enforceable contract with the Platform Owner for the Services.
        </li>
        <li>
          You shall indemnify and hold harmless Platform Owner, its affiliates, group companies (as applicable) and their respective officers, directors, agents, and employees, from any claim or demand, or actions including reasonable attorney’s fees, made by any third party or penalty imposed due to or arising out of your breach of these Terms of Use, Privacy Policy and other Policies, or your violation of any law, rules or regulations or the rights (including infringement of intellectual property rights) of a third party.
        </li>
        <li>
          Notwithstanding anything contained in these Terms of Use, the parties shall not be liable for any failure to perform an obligation under these Terms if performance is prevented or delayed by a force majeure event.
        </li>
        <li>
          These Terms and any dispute or claim relating to it, or its enforceability, shall be governed by and construed in accordance with the laws of India.
        </li>
        <li>
          All disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in Mumbai, Maharashtra.
        </li>
        <li>
          All concerns or communications relating to these Terms must be communicated to us using the contact information provided on this website.
        </li>
      </ul>

      <h2 className="text-2xl font-bold mt-10 mb-6">Privacy Policy</h2>

      <p className="text-sm mb-4">
        Introduction: This Privacy Policy describes how CineGuru and its affiliates (collectively “CineGuru, we, our, us”) collect, use, share, protect or otherwise process your information/personal data through our website cineguru.in (hereinafter referred to as Platform). Please note that you may be able to browse certain sections of the Platform without registering with us. We do not offer any product/service under this Platform outside India and your personal data will primarily be stored and processed in India.
      </p>

      <p className="text-sm mb-4">
        By visiting this Platform, providing your information or availing any product/service offered on the Platform, you expressly agree to be bound by the terms and conditions of this Privacy Policy, the Terms of Use and the applicable service/product terms and conditions, and agree to be governed by the laws of India including but not limited to the laws applicable to data protection and privacy. If you do not agree please do not use or access our Platform.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">Collection</h3>
      <p className="text-sm mb-4">
        We collect your personal data when you use our Platform, services or otherwise interact with us during the course of our relationship. Some of the information that we may collect includes but is not limited to name, date of birth, address, telephone/mobile number, email ID and/or any such information shared as proof of identity or address. Some sensitive personal data may be collected with your consent, such as bank account or payment information or biometric information (facial, physiological) where opted-in and permitted by law. You always have the option not to provide information by choosing not to use a particular service or feature on the Platform. We may also track your behavior and preferences on an aggregated basis.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">Usage</h3>
      <p className="text-sm mb-4">
        We use personal data to provide the services you request. To the extent we use your personal data to market to you, we will provide you the ability to opt-out. We also use your data to assist sellers/business partners, enhance customer experience, resolve disputes, inform you about offers, customize your experience, prevent fraud, enforce terms, conduct research, and as described when data is collected.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">Sharing</h3>
      <p className="text-sm mb-4">
        We may share your personal data within our group entities, affiliates, sellers, logistics partners, payment providers, and reward partners. We may also disclose data if required by law, to enforce policies, respond to legal requests or protect rights. We’re not responsible for third-party privacy practices—please review their policies.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">Security Precautions</h3>
      <p className="text-sm mb-4">
        We adopt reasonable security practices and procedures to safeguard your personal data. However, transmission over the Internet may not be fully secure. By using the Platform, you accept these inherent risks and are responsible for protecting your login credentials.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">Data Deletion and Retention</h3>
      <p className="text-sm mb-4">
        You can delete your account via profile settings or by contacting us. Pending grievances, claims or services may delay deletion. Once deleted, you lose access. We retain data only as needed or as required by law, but may anonymize it for future research or fraud prevention.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">Your Rights</h3>
      <p className="text-sm mb-4">
        You may access, rectify, and update your personal data through the Platform’s functionalities.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">Consent</h3>
      <p className="text-sm mb-4">
        By using the Platform, you consent to the collection and processing of your data in accordance with this Privacy Policy. You agree we may contact you via SMS, calls, emails, etc., unless you withdraw consent by writing to the Grievance Officer. Withdrawal is not retrospective and may affect service availability.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">Changes to This Policy</h3>
      <p className="text-sm mb-6">
        We may update this Privacy Policy over time. Check periodically for changes. We may notify you of significant updates as required by law.
      </p>

      <div className="border-t pt-6 mt-8">
        <h2 className="text-2xl font-bold mb-4">Refund &amp; Cancellation Policy</h2>

        <p className="text-sm mb-4">
          This refund and cancellation policy outlines how you can cancel or seek a refund for a product/service purchased through the Platform. Under this policy:
        </p>

        <ul className="list-decimal list-inside text-sm space-y-2">
          <li>
            Cancellations will only be considered if the request is made within 30 days of placing the order. Cancellation requests may not be entertained if the order has been communicated to sellers and shipping has begun. In such a case, the user may reject the product at the doorstep.
          </li>
          <li>
            CineGuru does not accept cancellation requests for perishable items like flowers or eatables. However, refunds/replacements may be provided if the user demonstrates poor quality of the delivered product.
          </li>
          <li>
            In case of damaged or defective items, please report to our customer service team within 30 days of receipt. A refund or replacement depends on seller/merchant confirmation.
          </li>
          <li>
            If the product is not as shown or not meeting expectations, report within 30 days of receipt. Customer service will investigate and decide accordingly.
          </li>
          <li>
            For products with manufacturer warranties, customers are advised to approach the manufacturer directly for issues.
          </li>
          <li>
            Approved refunds will be processed within 30 days.
          </li>
        </ul>

        <div className="mt-8 text-sm">
          <p><strong>Contact Us:</strong> CineGuru, 129, Kartik Building, Link Road, Andheri West, Mumbai.</p>
          <p><strong>Phone Support:</strong> Monday – Friday (9:00 – 18:00)</p>
        </div>
      </div>
    </Container>
    </Layout>

  );
};

export default TermsAndConditions;
